(function () {
  if (window.__copecRecentlyViewed) return;
  window.__copecRecentlyViewed = true;

  var STORAGE_KEY = 'copec-recently-viewed';
  var MAX_VISIBLE = 10;
  var HANDLE_PATTERN = /^[a-z0-9][a-z0-9_-]{0,254}$/;

  function read() {
    try {
      var parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(parsed)) return [];
      return parsed
        .filter(function (handle) {
          return typeof handle === 'string' && HANDLE_PATTERN.test(handle);
        })
        .slice(0, MAX_VISIBLE);
    } catch (error) {
      return [];
    }
  }

  function write(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, MAX_VISIBLE)));
    } catch (error) {}
  }

  function remember(handle) {
    var normalized = String(handle || '').toLowerCase();
    if (!HANDLE_PATTERN.test(normalized)) return;
    var next = [normalized].concat(
      read().filter(function (item) {
        return item !== normalized;
      })
    );
    write(next);
  }

  function forget(handle) {
    write(
      read().filter(function (item) {
        return item !== handle;
      })
    );
  }

  function forgetMany(handles) {
    var drop = {};
    handles.forEach(function (handle) {
      drop[handle] = true;
    });
    write(
      read().filter(function (handle) {
        return !drop[handle];
      })
    );
  }

  function currentHandle() {
    var node = document.getElementById('RecentlyViewedCurrentProduct');
    if (!node) return '';
    try {
      var data = JSON.parse(node.textContent || '{}');
      return data && data.handle ? String(data.handle).toLowerCase() : '';
    } catch (error) {
      return '';
    }
  }

  function productUrl(root, handle) {
    var base = root && root.charAt(root.length - 1) === '/' ? root : (root || '/') + '/';
    if (base === '//') base = '/';
    return base + 'products/' + encodeURIComponent(handle) + '?view=recently-viewed-card';
  }

  function sectionWrapper(section) {
    return (
      document.getElementById('shopify-section-' + section.dataset.sectionId) ||
      section.closest('.shopify-section') ||
      section
    );
  }

  function setVisible(section, visible) {
    var wrapper = sectionWrapper(section);
    wrapper.classList.toggle('recently-viewed-is-empty', !visible);
    var carousel = section.querySelector('[data-recently-viewed-carousel]');
    var note = section.querySelector('[data-recently-viewed-empty]');
    if (carousel) carousel.hidden = !visible;
    if (note) note.hidden = visible;
  }

  function destroyCarousel(section) {
    var carousel = section.querySelector('[data-recently-viewed-carousel]');
    if (!carousel) return;
    var instance = carousel.swiperInstance;
    var shell = carousel.querySelector('.swiper');
    if (!instance && shell && shell.swiper) instance = shell.swiper;
    if (instance && typeof instance.destroy === 'function') {
      instance.destroy(true, true);
    }
    carousel.swiperInstance = null;
    delete carousel.dataset.swiperInitialized;
  }

  function initCarousel(section) {
    var carousel = section.querySelector('[data-recently-viewed-carousel]');
    if (!carousel || !carousel.querySelector('.swiper-slide')) return;
    carousel.hidden = false;
    destroyCarousel(section);
    carousel.setAttribute('data-swiper-carousel', '');
    if (typeof window.initSwiperCarousels === 'function') {
      window.initSwiperCarousels();
    }
  }

  function fillSlides(section, entries) {
    var list = section.querySelector('[data-recently-viewed-list]');
    var template = section.querySelector('[data-recently-viewed-slide]');
    var label = section.dataset.removeLabel || '';
    if (!list || !template) return;
    var fragment = document.createDocumentFragment();
    entries.forEach(function (entry) {
      var node = template.content.firstElementChild.cloneNode(true);
      node.dataset.productHandle = entry.handle;
      var slot = node.querySelector('[data-recently-viewed-slot]');
      if (slot) slot.innerHTML = entry.html;
      var button = node.querySelector('[data-recently-viewed-dismiss]');
      if (button) {
        button.setAttribute('aria-label', label.split('__TITLE__').join(entry.title || entry.handle));
      }
      fragment.appendChild(node);
    });
    list.replaceChildren(fragment);
  }

  function loadCards(section, handles) {
    var root = section.dataset.root || '/';
    return Promise.all(
      handles.map(function (handle) {
        return fetch(productUrl(root, handle), {
          credentials: 'same-origin',
          headers: { Accept: 'text/html' },
        })
          .then(function (response) {
            if (response.status === 404) return { handle: handle, missing: true };
            if (!response.ok) return { handle: handle, missing: false };
            return response.text().then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var card = doc.querySelector('[data-recently-viewed-card]');
              if (!card) return { handle: handle, missing: false };
              return {
                handle: handle,
                html: card.innerHTML,
                title: card.getAttribute('data-product-title') || handle,
              };
            });
          })
          .catch(function () {
            return { handle: handle, missing: false };
          });
      })
    );
  }

  function hasPreview(section) {
    return !!section.querySelector('[data-recently-viewed-list] .swiper-slide');
  }

  function mount(section) {
    if (section.dataset.recentlyViewedReady === 'true') return;
    section.dataset.recentlyViewedReady = 'true';
    bindDismiss(section);

    var activeHandle = currentHandle();
    var handles = read()
      .filter(function (handle) {
        return handle !== activeHandle;
      })
      .slice(0, MAX_VISIBLE);

    if (!handles.length) {
      if (section.dataset.designMode === 'true' && hasPreview(section)) {
        initCarousel(section);
        return;
      }
      if (section.dataset.designMode !== 'true') setVisible(section, false);
      return;
    }

    loadCards(section, handles)
      .then(function (entries) {
        var missing = entries
          .filter(function (entry) {
            return entry.missing;
          })
          .map(function (entry) {
            return entry.handle;
          });
        if (missing.length) forgetMany(missing);

        var found = entries.filter(function (entry) {
          return entry.html;
        });
        if (!found.length) {
          if (section.dataset.designMode === 'true' && hasPreview(section)) {
            initCarousel(section);
            return;
          }
          if (section.dataset.designMode !== 'true') setVisible(section, false);
          return;
        }

        destroyCarousel(section);
        fillSlides(section, found);
        setVisible(section, true);
        requestAnimationFrame(function () {
          var list = section.querySelector('[data-recently-viewed-list]');
          if (list && window.Alpine && typeof window.Alpine.initTree === 'function') {
            window.Alpine.initTree(list);
          }
          initCarousel(section);
        });
      })
      .catch(function () {
        if (section.dataset.designMode !== 'true') setVisible(section, false);
      });
  }

  function focusAfterRemove(section, nextFocus) {
    if (nextFocus && nextFocus.isConnected) {
      var nextButton = nextFocus.querySelector('[data-recently-viewed-dismiss]');
      if (nextButton) {
        nextButton.focus();
        return;
      }
    }
    var heading = section.querySelector('[data-recently-viewed-heading]');
    if (heading) heading.focus();
  }

  function bindDismiss(section) {
    if (section.dataset.dismissBound === 'true') return;
    section.dataset.dismissBound = 'true';

    section.addEventListener('click', function (event) {
      var button = event.target.closest('[data-recently-viewed-dismiss]');
      if (!button || !section.contains(button)) return;
      event.preventDefault();
      event.stopPropagation();

      var slide = button.closest('.swiper-slide');
      if (!slide) return;
      var handle = slide.dataset.productHandle;
      if (handle) forget(handle);

      var carousel = section.querySelector('[data-recently-viewed-carousel]');
      var swiper = carousel && (carousel.swiperInstance || (carousel.querySelector('.swiper') || {}).swiper);
      var nextFocus = slide.nextElementSibling || slide.previousElementSibling;

      if (swiper && typeof swiper.removeSlide === 'function') {
        var index = Array.prototype.indexOf.call(swiper.slides, slide);
        if (index >= 0) swiper.removeSlide(index);
        else slide.remove();
        if (typeof swiper.update === 'function') swiper.update();
      } else {
        slide.remove();
      }

      var remaining = section.querySelectorAll('[data-recently-viewed-list] .swiper-slide').length;
      if (!remaining) {
        var isEditor = section.dataset.designMode === 'true';
        setVisible(section, false);
        if (isEditor) {
          focusAfterRemove(section, null);
        } else {
          var main = document.getElementById('MainContent');
          if (main) main.focus();
        }
        return;
      }
      focusAfterRemove(section, nextFocus);
    });
  }

  function boot() {
    var handle = currentHandle();
    if (handle) remember(handle);
    document.querySelectorAll('[data-recently-viewed]').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-recently-viewed]');
    if (!section) return;
    var handle = currentHandle();
    if (handle) remember(handle);
    mount(section);
  });

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll('[data-recently-viewed]').forEach(function (section) {
      delete section.dataset.recentlyViewedReady;
      mount(section);
    });
  });
})();
